/*
 * File: DemographicsPage.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Demographics landing page
 */
import React from "react";
import DemographicLinks from "./DemographicsLinks";
import { withStyles } from "@material-ui/core/styles";
import { Toolbar } from "@material-ui/core";
import PropTypes from "prop-types";
import PatientChart from "../topofthechart/PatientChart";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    paddingBottom: theme.spacing(0.5),
    marginTop: theme.spacing(2.5)
  }
});

const DemographicsPage = ({ classes }) => (
  <React.Fragment>
    <PatientChart />
    <Toolbar className={classes.toolbar}>
      <MainHeader pageTitle="Demographics" pageSubtitle="Patient" />
    </Toolbar>
    <DemographicLinks />
  </React.Fragment>
);

DemographicsPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DemographicsPage);
